export enum StepComponentType {
  TravelInformationStep = 1,
  CarInformationStep = 2,
  ResultStep = 3,
}
